export class UserInfo {
    id: number;
   public username: string;
    email: string;
    roles: number;
    tokenType: string;
    accessToken: string;
}